import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileLoadingOutLined } from '@whelk/assets/src/web/icons';

export function Loading() {
  const { t } = useTranslation();
  return (
    <div className='w-ful flex h-full flex-col items-center justify-center'>
      <FileLoadingOutLined />
      <div className='mt-[5px] text-[14px] font-[400px] leading-[20px] text-[#7A7E8B]'>
        {t('file_preview_loading')}
      </div>
    </div>
  );
}
